import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery, Button, CardMedia, Skeleton, Grid, CardActionArea, Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import ArticleControls from "./ArticleControls.js";
import Tags from "../Tags.js";
import { ChevronLeft, ChevronRight, Visibility } from "@mui/icons-material";
import { Add } from "@mui/icons-material";
import { default as EventBus } from '../../utils/EventBus.js'
import CommunityEventNames from '../EventNames.js'
import { editArticleMetadata, createArticle } from '../utils.js'
import CircularProgress from '@mui/material/CircularProgress';
import DeleteArticleDialog from "./DeleteArticleDialog.js";

export default function SmallArticleList(props = {}) {
  const navigate = useNavigate()

  const [deleteArticleDialogOpen, setDeleteArticleDialogOpen] = useState(false)
  const [article, setArticle] = useState()

  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.down('xl'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  const deleteArticle = (article) => {
    setArticle(article)
    setDeleteArticleDialogOpen(true)
  }

  const addArticle = () => {
    EventBus.emit(CommunityEventNames.OPEN_ADD_EDIT_ARITCLE_DIALOG, {
      mode: 'add',
      article: {
        featured,
        news,
        ouCorner,
        highlighted,
        ouCornerCategory
      },
      visibility: {
        featured,
        news,
        ouCorner,
        highlighted,
        ouCornerCategory
      }
    })
  }

  const viewArticle = (article) => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      navigate(article.guid)
    }
  }

  const {
    articles,
    loading,
    loadingMore,
    editable,
    featured,
    news,
    ouCorner,
    highlighted,
    ouCornerCategory,
    published,
    showPrevious,
    showNext,
    onPrevious,
    onNext,
  } = props

  const [hovering, setHovering] = useState()
  const verticalPaging = isSm || isMd

  const Wrapper = (props = {}) => {

    if (showNext) return <Grid container gap={0}>
      {/* Previous */}
      {showPrevious && <Grid xs={verticalPaging ? 12 : .5} className="mid-align-flex center-justify-flex ">
        <Button size='small' sx={{ minWidth: '100% !important', width: '100%', height: '100%' }} onClick={onPrevious}>
          {loadingMore && <CircularProgress />}
          {!loadingMore && <ChevronLeft sx={{ color: 'grey', transform: verticalPaging ? 'rotate(90deg)' : undefined }} fontSize="large" />}
        </Button>
      </Grid>}

      {/* Articles */}
      <Grid item xs={verticalPaging ? 12 : showPrevious ? 11 : 11.5}>
        {props.children}
      </Grid>

      {/* Next */}
      {showNext && <Grid xs={verticalPaging ? 12 : .5} className="mid-align-flex center-justify-flex">

        <Button size='small' sx={{ minWidth: '100% !important', width: '100%', height: '100%' }} onClick={onNext}>
          {loadingMore && <CircularProgress />}
          {!loadingMore && <ChevronRight sx={{ color: 'grey', transform: verticalPaging ? 'rotate(90deg)' : undefined }} fontSize="large" />}
        </Button>
      </Grid>}
    </Grid>

    return <>{props.children}</>
  }

  return <Wrapper>
    <DeleteArticleDialog
      open={deleteArticleDialogOpen}
      article={article}
      onClose={() => setDeleteArticleDialogOpen(false)}
    />
    <Grid container gap={0} className={!loading ? 'article-section' : ''}>
      {editable && !loading && <Grid item xs={12} className="add-icon">
        <div className="article-controls-backdrop">
          <IconButton onClick={addArticle} size='medium' className="icon-button">
            <Add />
          </IconButton>
        </div>
      </Grid>}
      {loading && <Grid container gap={0}>
        <Grid item xs={12} className="tertiary-article-height">
          <Skeleton className="fit-height"></Skeleton>
        </Grid>
      </Grid>}

      {!loading && !articles?.length && <span>No Articles</span>}
      {!loading && articles?.map((article, index) => (
        <Grid key={`article_${index}`} item xs={12} sm={12} md={12} lg={6} xl={3} className="article-tile">
          <Card key={index} className={`tertiary-article-card tertiary-article-height`}>
            <CardActionArea
              component="div"
              className="tertiary-article-height"
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
              onMouseOver={() => setHovering(index)}
              onMouseOut={() => setHovering()}
              onClick={() => viewArticle(article)}
            >
              <CardMedia className='featured-image tertiary-article-height' component="div" sx={{ backgroundImage: `url(${article?.image})`, width: '170px !important', float: 'left' }} alt="Featured Article" />
              <CardMedia className='featured-image-blurred tertiary-article-height' component="div" sx={{ backgroundImage: `url(${article?.image})`, width: '170px !important', float: 'left' }} alt="Featured Article" />

              <CardContent className="tertiary-article-content" sx={{ maxWidth: 'calc(100% - 170px)' }}>
                <Box className="tertiary-article-header text-clamp">
                  <Typography variant="h6" className="tertiary-article-title">
                    {article.title}
                  </Typography>
                </Box>

                <Typography noWrap={false} variant="caption" className="tertiary-article-meta">
                  {article.author} - {article.date}
                </Typography>

                <Tags
                  tags={article?.tags || ""}
                  onSelectTag={_ => setHovering()}
                  clickable={published}
                  sx={{
                    overflow: 'hidden',
                    height: '50px',
                    alignItems: 'flex-start'
                  }}
                />

              </CardContent>

              {editable && <ArticleControls
                hovering={hovering === index}
                isDraft={article.isDraft}
                isPinned={article?.metadata?.isPinned}
                layout='horizontal'
                onClickAdd={createArticle}
                onClickEdit={() => editArticleMetadata(article, {
                  featured,
                  news,
                  ouCorner,
                  highlighted,
                  ouCornerCategory,
                })}
                onClickDelete={() => deleteArticle(article)}
                article={article}
              />}
            </CardActionArea>

          </Card>
        </Grid>
      ))}

    </Grid>
  </Wrapper>
}